import { ReactNode } from 'react';
import OutsideFrame from '../components/templates/outside-frame';
import InsideFrame from '../components/templates/inside-frame';

// 共通フレームの構築処理
export const addOutsideFrame = (children: ReactNode) => <OutsideFrame>{children}</OutsideFrame>;
export const addInsideFrame = (children: ReactNode) => <InsideFrame>{children}</InsideFrame>;
